import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import Zeitaufzeichnung from './Zeitaufzeichnung';
import '../styles/Dashboard.css';

type ViewType = 'home' | 'zeitaufzeichnung';

const Dashboard: React.FC = () => {
  const { user, logout } = useAuth();
  const [currentView, setCurrentView] = useState<ViewType>('home');

  const handleLogout = async () => {
    await logout();
  };

  return (
    <div className="dashboard-container">
      <nav className="navbar">
        <div className="navbar-brand">
          <h1>BlackWhite</h1>
        </div>
        <div className="navbar-menu">
          <button
            onClick={() => setCurrentView('home')}
            className={`nav-button ${currentView === 'home' ? 'active' : ''}`}
          >
            Home
          </button>
          <button
            onClick={() => setCurrentView('zeitaufzeichnung')}
            className={`nav-button ${currentView === 'zeitaufzeichnung' ? 'active' : ''}`}
          >
            Zeitaufzeichnung
          </button>
          <button onClick={handleLogout} className="logout-button">
            Abmelden
          </button>
        </div>
      </nav>

      <div className="dashboard-content">
        {currentView === 'home' ? (
          <div className="welcome-card">
            <h2>Willkommen zurück!</h2>
            {user && (
              <div className="user-info">
                <p><strong>Benutzername:</strong> {user.username}</p>
                <p><strong>E-Mail:</strong> {user.email || '-'}</p>

                {user.mitarbeiter && (
                  <>
                    <h3>Mitarbeiter-Information</h3>
                    <p><strong>Name:</strong> {user.mitarbeiter.vorname} {user.mitarbeiter.nachname}</p>
                    <p><strong>Rolle:</strong> {user.mitarbeiter.rolle}</p>
                    <p><strong>Telefon:</strong> {user.mitarbeiter.telefon || '-'}</p>
                    <p><strong>Status:</strong> {user.mitarbeiter.ist_aktiv ? 'Aktiv' : 'Inaktiv'}</p>
                    {user.mitarbeiter.winchim_mitarbeiter_id && (
                      <p><strong>WinChim ID:</strong> {user.mitarbeiter.winchim_mitarbeiter_id}</p>
                    )}
                  </>
                )}
              </div>
            )}
          </div>
        ) : (
          <Zeitaufzeichnung />
        )}
      </div>
    </div>
  );
};

export default Dashboard;
